import React from 'react';
import { Route } from 'react-router-dom';
//pages
export const NotFoundRoute = props => (
    <Route
        render={props => (
            <h1>
                {' '}
                Page is not found <bold>404.e</bold>{' '}
            </h1>
        )}
    />
);



// WEBPACK FOOTER //
// ./src/UI/App/routes/NotFoundRoute.js